import { render } from "./CommentaryLine.vue?vue&type=template&id=ea94624e&ts=true"
import script from "./CommentaryLine.vue?vue&type=script&lang=ts"
export * from "./CommentaryLine.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__